import React from "react";
import Header from "../../Components/layouts/Header";
import TableData from "./Tabledata";

const Health = () => {
  console.log(TableData)
  return (
    <>
      <Header title="Crop Advisary" subtitle="Health" />
      <section className="p-[1%] grid gap-y-2">
        <div className="grid grid-cols-[30%_30%_30%_10%] ">
          <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
            <label className="text-[#13490A] text-center">Type</label>
            <input
              type="text"
              className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
            />
            <img src="Images/Dropdown.png" className="px-4" />
          </div>
          <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
            <label className="text-[#13490A] text-center">Crop</label>
            <input
              type="text"
              className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
            />
            <img src="Images/Dropdown.png" className="px-4" />
          </div>
          <div className="font-extrabold grid grid-cols-[30%_50%_20%] items-center">
            <label className="text-[#13490A] text-center">Variety</label>
            <input
              type="text"
              className="bg-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] rounded-md text-center h-8"
            />
            <img src="Images/Dropdown.png" className="px-4" />
          </div>
          <button className="bg-[#05AB2A] text-[#F3FFF1] shadow-[4px_4px_3px_rgba(0,0,0,0.25)] font-light rounded-md h-8">
            Go
          </button>
        </div>
        <table className="table-fixed border-collapse border border-black font-bold text-base mx-auto">
          <thead className="border-b border-black">
            <tr className="text-center">
              <th className="border-r border-black py-[1.2%]">S.NO</th>
              <th className="border-r border-black py-[1.2%]">Name</th>
              <th className="border-r border-black py-[1.2%]">Image</th>
              <th className="border-r border-black py-[1.2%]">Description</th>
              <th className="border-r border-black py-[1.2%]">Solution</th>
            </tr>
          </thead>
          <tbody>
            {
              TableData.map((curr) => {
                return (
                  <tr className="border-b border-black text-center">
                    <td className="border-r border-black">{curr.sNo}</td>
                    <td className="border-r border-black">{curr.name}</td>
                    <td className="border-r border-black">
                      <div className="grid grid-cols-[50%_50%]">
                        <img src={curr.image1} alt="ImageCrop" className="h-full" />
                        <img src={curr.image2} alt="ImageCrop" className="h-full" />
                      </div>
                    </td>
                    <td className="border-r border-black w-[35%]">{curr.description}</td>
                    <td className="border-r border-black flex flex-col justify-center items-center">
                      {curr.solutionName}
                      <img src={curr.solution} alt='solution' className="h-4/5 w-4/5" />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </section>
    </>
  );
};

export default Health;
